import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { purifier } from '../../../utils/dom';
import { cleanInternalLinks } from '../../../utils/string';

const Button = ({ content, attrs = {}, isManyButtons = 1 }) => {
	const variantClasses = ['button__content'];

	if (isManyButtons > 1) variantClasses.push('button__multiple');
	if (attrs.outline) variantClasses.push('button__outline');
	if (attrs.fullWidth) variantClasses.push('button__fullWidth');
	if (attrs.fontSize) variantClasses.push(`button__${attrs.fontSize}`);
	if (attrs.className) variantClasses.push(`button_${attrs.className}`);

	if (!content.rawText) return null;

	return (
		<ButtonElement type="link" location={cleanInternalLinks(content.attrs.href)} variantClasses={variantClasses}>
			<span dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
		</ButtonElement>
	);
};

export default hot(module)(Button);
